export default __webpack_public_path__ + "static/media/help_icon.649cd5f1.png";